var _defs, _g, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManageCampaign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__campaign-24px",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-2{fill:#757575}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_815",
    "data-name": "Group 815"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_2379",
    fill: "none",
    d: "M0 0H24V24H0z",
    "data-name": "Rectangle 2379"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_476",
    d: "M18 11v2h4v-2z",
    className: "prefix__cls-2",
    "data-name": "Path 476"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_477",
    d: "M16 17.61c.96.71 2.21 1.65 3.2 2.39.4-.53.8-1.07 1.2-1.6-.99-.74-2.24-1.68-3.2-2.4-.4.54-.8 1.08-1.2 1.61z",
    className: "prefix__cls-2",
    "data-name": "Path 477"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_478",
    d: "M20.4 5.6c-.4-.53-.8-1.07-1.2-1.6-.99.74-2.24 1.68-3.2 2.4.4.53.8 1.07 1.2 1.6.96-.72 2.21-1.65 3.2-2.4z",
    className: "prefix__cls-2",
    "data-name": "Path 478"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_479",
    d: "M4 9a2.006 2.006 0 0 0-2 2v2a2.006 2.006 0 0 0 2 2h1v4h2v-4h1l5 3V6L8 9zm5.03 1.71L11 9.53v4.94l-1.97-1.18-.48-.29H4v-2h4.55z",
    className: "prefix__cls-2",
    "data-name": "Path 479"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_480",
    d: "M15.5 12A4.48 4.48 0 0 0 14 8.65v6.69A4.442 4.442 0 0 0 15.5 12z",
    className: "prefix__cls-2",
    "data-name": "Path 480"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageCampaign);
export default __webpack_public_path__ + "static/media/manageCampaign.80fea93e.svg";
export { ForwardRef as ReactComponent };